module.exports = __webpack_public_path__ + "img/3.282f82c7.png";